var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"logo108 text-center"},[_c('align-middle',[_c('lio',{attrs:{"h":27,"w":50}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }